"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfRenewalQuoteMTADeclineWordings = void 0;
var WolfRenewalQuoteMTADeclineWordings = /** @class */ (function () {
    function WolfRenewalQuoteMTADeclineWordings() {
        this.defaultMessage = " we can't insure you";
        this.changeInDriversHistorySoft = "the driver's driving history";
        this.changeInDriversHistoryHard = "the change of driving history";
        this.changeInDriversAge = "the driver's age";
        this.changeInCarDetailsSoft = "the change of car details";
        this.changeInAddressHard = "the change of address";
        this.changeInRiskSoft = "the change in risk";
        this.changeInRiskHard = "the change of details";
        this.changeInCarUsage = "the change of car usage";
        this.calculationHalted = "calculation halted - Too many input errors, Terminating Application";
        this.mtaLimitReached = this.defaultMessage;
    }
    return WolfRenewalQuoteMTADeclineWordings;
}());
exports.WolfRenewalQuoteMTADeclineWordings = WolfRenewalQuoteMTADeclineWordings;
//# sourceMappingURL=WolfRenewalQuoteMTADeclineWordings.js.map